module.exports = require("whatwg-fetch");


//////////////////
// WEBPACK FOOTER
// external "whatwg-fetch"
// module id = 133
// module chunks = 0